import React, { useState } from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectGemeinde } from "../../redux/gemeinde/gemeinde.selector";
import { selectCurrentUser } from "../../redux/user/user.selector";
import { saveReport } from "../../redux/reports/report.actions";
import {
  makeStyles,
  Card,
  CardActionArea,
  CardMedia,
  Typography,
  CardContent,
  CardActions,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import { useEffect } from "react";
import { getPreviewImageUrl } from "../../utils/cloudinary/cloudinary-service";

const useStyles = makeStyles({
  root: {
    maxWidth: 350,
    width: 350,
    margin: "20px",
  },
  media: {
    height: 250,
  },
  date: {
    position: "absolute",
    top: "20px",
    right: "20px",
    color: "#DF013A",
    backgroundColor: "rgba(200, 200, 200, 0.6)",
    paddingLeft: 5,
    paddingRight: 5,
  },
});

const ReportOverviewComponent = ({
  bericht,
  gemeinde,
  currentUser,
  history,
  saveReport,
}) => {
  const classes = useStyles();
  const [imageUrl, setImageUrl] = useState("/image/weiss.jpg");
  const [dialog, setDialog] = useState("");
  useEffect(() => {
    bericht.bild1 && getPreviewImageUrl(bericht.bild1, setImageUrl);
  }, [bericht]);
  return (
    <Card className={classes.root}>
      <CardActionArea onClick={() => history.push("/bericht/" + bericht.id)}>
        <CardMedia
          className={classes.media}
          title={bericht.title}
          image={imageUrl}
        />
        <CardContent>
          {bericht.bewertungsende &&
          bericht.bewertungsende.seconds * 1000 > Date.now() ? (
            <Typography className={classes.date}>
              {moment(bericht.bewertungsende.seconds * 1000).fromNow()}
            </Typography>
          ) : null}
          <Typography gutterBottom variant="h6" component="h2">
            {bericht.titel}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {bericht.frage1.length > 200
              ? bericht.frage1.substring(0, 197) + "..."
              : bericht.frage1}
          </Typography>
        </CardContent>
      </CardActionArea>
      {gemeinde && gemeinde.id === bericht.gemeindeId ? (
        <CardActions>
          {!bericht.freigabe ||
          (bericht.bewertungsende &&
            bericht.bewertungsende.seconds > Date.now() / 1000 &&
            currentUser.isSaemann) ? (
            <Button
              size="small"
              onClick={() => history.push("/bericht-edit/" + bericht.id)}
            >
              Bearbeiten
            </Button>
          ) : null}
          {!bericht.freigabe && currentUser.isSaemann ? (
            <>
              <Button size="small" onClick={() => setDialog("freigeben")}>
                Freigeben
              </Button>
              <Button size="small" onClick={() => setDialog("loeschen")}>
                Löschen
              </Button>
            </>
          ) : null}
        </CardActions>
      ) : null}
      <Dialog open={dialog === "loeschen"} onClose={() => setDialog("")}>
        <DialogTitle>Möchten Sie diesen Bericht wirklich löschen?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {'Der Bericht "' +
              bericht.titel +
              '" wird damit dauerhaft für alle Nutzer entfernt!'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog("")}>Abbrechen</Button>
          <Button
            onClick={() => {
              setDialog("");
              saveReport({ ...bericht, geloescht: true });
            }}
          >
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={dialog === "freigeben"} onClose={() => setDialog("")}>
        <DialogTitle>
          Möchten Sie diesen Bericht wirklich freigeben?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {'Der Bericht "' +
              bericht.titel +
              '" kann dann nur noch vom Sämann bearbeitet werden und der Bewertungszeitraum von 2 Monaten startet!'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog("")}>Abbrechen</Button>
          <Button
            onClick={() => {
              setDialog("");
              saveReport({
                ...bericht,
                freigabe: true,
                bewertungsende: new Date(
                  +moment()
                    .add(2, "M")
                    .endOf("day")
                ),
              });
            }}
          >
            Freigeben
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};
/*
<div class="MuiCardMedia-root makeStyles-media-208" style="background-image: url(&quot;http://res.cloudinary.com/hpem9lppc/image/upload/c_fit,w_300/wofkkjfvqmsucxygt8he.png&quot;);"></div>
return (
    <div className="reportpreview">
      <div className="previewcontent">
        <div className="fotocontainer">
          {bericht.bild1 ? (
            <Image
              key={bericht.bild1}
              publicId={bericht.bild1 + ".png"}
              className="fotos"
              width="150"
            >
              <Transformation
                quality="auto"
                radius="10"
                width="150"
                crop="fit"
              />
            </Image>
          ) : null}
        </div>
        <div className="previewtexts">

          <h3 onClick={() => history.push("/bericht/" + bericht.id)}>
            {bericht.titel}
          </h3>
          {bericht.frage1 ? (
            <h3>
              {bericht.frage1.length > 201
                ? bericht.frage1.substring(0, 200) + "..."
                : bericht.frage1}
            </h3>
          ) : null}
          <h3>Autor: {bericht.autor}</h3>
        </div>
      </div>
      <div className="previewbuttons">
        {(!bericht.isClosed &&
          gemeinde &&
          bericht.gemeindeId === gemeinde.id &&
          !bericht.isOpen) ||
        (currentUser && currentUser.isSaemann) ? (
          <CustomButton
            onClick={() => history.push("/bericht-edit/" + bericht.id)}
          >
            Bearbeiten
          </CustomButton>
        ) : null}
        {!bericht.isOpen &&
        !bericht.isClosed &&
        currentUser &&
        currentUser.isSaemann ? (
          <CustomButton>Löschen</CustomButton>
        ) : null}
      </div>
    </div>
  );
};*/

const mapDispatchToProps = (dispatch) => ({
  saveReport: (report) => dispatch(saveReport(report)),
});

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  gemeinde: selectGemeinde,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReportOverviewComponent)
);
